import React, { Fragment, useState, useEffect } from 'react'
import { bool, func } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Link from 'common/components/link'
import Button from 'common/components/button'
import Icon from 'common/components/icon'
import * as profileActions from 'services/app-state/profile/actions'
import AccountMenu from 'components/account-menu'
import { REGISTER_LINK, SIGNIN_LINK, BTC_REGISTER_LINK } from 'services/utility/constants'
import { trackSignalEvent } from 'services/utility/analytics'

const Profile = ({
  isSignedIn,
  getProfile,
  signOut,
  isBabyClubHeader,
  isBabyClubMember,
}) => {
  
  const [showAccountMenu, setShowAccountMenu] = useState(false)
  const handleClick = (e) => {
    const { innerText = '' } = e.target || {}
    trackSignalEvent('RegisterLoginLinkClick', { buttonText: innerText, pageName: document.title })
  }

  return (
    <Fragment>
      {
        (isBabyClubMember && isBabyClubHeader) || (!isBabyClubHeader && isSignedIn) ? (
          <li className="sign-in_btn">
            <Button
              clickHandler={() => setShowAccountMenu(!showAccountMenu)}
              className="asda-btn--plain profile-link acc-btn"
              disabled={showAccountMenu}
              dataAutoId="btnAccount"
            >
              Your Account
              <Icon name="chevron-down" size="small" />
            </Button>
          </li>
        ) : null
      }
      { !isSignedIn || (isBabyClubHeader && !isBabyClubMember) ?
        (
          <Fragment>
            {!isBabyClubHeader &&
              <li>
                <Link
                  href={REGISTER_LINK}
                  asAnchor
                  className="profile-link"
                  onClick={handleClick}
                  dataAutoId="btnRegister"
                >
                  Register
                </Link>
              </li> }
            <li className="sign-in_btn">
              <Button
                href={(isBabyClubHeader && isSignedIn && !isBabyClubMember)
                  ? BTC_REGISTER_LINK : SIGNIN_LINK}
                asAnchor
                className={`asda-btn--secondary ${!isBabyClubHeader && 'profile-link'}`}
                onClick={handleClick}
                dataAutoId="btnSign"
              >
                {isBabyClubHeader ? `Join now` : `Sign in`}
              </Button>
            </li>
          </Fragment>
        ) : null
      }
      { showAccountMenu && isSignedIn ? (
        <AccountMenu
          signOut={signOut}
          setShowAccountMenu={setShowAccountMenu}
        />
        ) : null }
    </Fragment>
  )
}

Profile.propTypes = {
  isSignedIn: bool.isRequired,
  getProfile: func.isRequired,
  signOut: func.isRequired,
  isBabyClubHeader: bool,
  isBabyClubMember: bool,
}

Profile.defaultProps = {
  isBabyClubHeader: false,
  isBabyClubMember: false,
}
const mapStateToProps = ({ profile }) => {
  const { isBabyClubMember, isSignedIn } = profile
  return {
    isSignedIn,
    isBabyClubMember,
  }
}

const mapDispatchToProps = dispatch => ({
  getProfile: bindActionCreators(profileActions.getProfile, dispatch),
  signOut: bindActionCreators(profileActions.signOut, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./components/header/asda-com/Profile.js